import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import Phone from '../../components/Phone';
import { TRANSLATION_FILES } from '../../constants/translation';
import { SPA_LAWYER_REP_OPTIONS } from '../../constants/lawyerCaseStatuses';
import ModalConfirm from '../modals/ModalConfirm';

class SecondaryLawyerDetail extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    cancelled: PropTypes.bool,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    t: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
  }
  static defaultProps = {
    basic: false,
    cancelled: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showModalConfirmDelete: false,
    };
  }
  handleOnEdit = (e) => {
    e.preventDefault();
    if (this.props.onEdit) {
      this.props.onEdit();
    }
  }
  handleOnDelete = (e) => {
    e.preventDefault();
    if (this.props.onDelete) {
      this.props.onDelete();
    }
  }
  handleShowModalConfirmDelete = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showModalConfirmDelete: true,
    });
  }
  handleCloseModalConfirmDelete = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showModalConfirmDelete: false,
    });
  }
  renderCurrent = () => {
    const { data, t } = this.props;
    return (
      <Grid stackable>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Name')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                {data.name}
              </div>
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Law Firm')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.lawFirmName}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Contact No')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              <Phone
                mobilePrefix={data.mobilePrefix}
                mobile={data.mobile}
              />
            </Grid.Column>
          </Grid>
        </Grid.Column>

        <Grid.Column mobile={16} tablet={8} computer={8}>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Address 1')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                {data.address1}
              </div>
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Address 2')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.address2 || '-'}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Address 3')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.address3 || '-'}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Postcode')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.postcode}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('City')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.city}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('State')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.state}
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    );
  }
  renderCancelled = () => {
    const { data, t } = this.props;
    return (
      <Grid>
        <Grid.Column width={16}>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Name')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                {data.name}
              </div>
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Law Firm')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              {data.lawFirmName}
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={6}>
              {t('Contact No')}
            </Grid.Column>
            <Grid.Column textAlign="right" width={10}>
              <Phone
                mobilePrefix={data.mobilePrefix}
                mobile={data.mobile}
              />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    );
  }

  render() {
    const { cancelled, data, t } = this.props;
    return (
      <Grid.Column style={{ textAlign: 'left' }}>
        <ModalConfirm
          open={this.state.showModalConfirmDelete}
          onClose={this.handleCloseModalConfirmDelete}
          onConfirm={this.handleOnDelete}
          headerNode={`${t('Delete lawyer')}?`}
          content={`${t('Are you sure you want to delete this lawyer? This action will not be reversible')}.`}
        />
        { !cancelled && <Divider /> }
        { !cancelled && <Header>{t('Additional SPA Lawyer')}</Header>}
        { !cancelled && <p>Only for HIMS e-SPA purpose</p>}
        { data.id ? (
          <Segment className="SecondLawyerDetails" tertiary={cancelled}>
            { !cancelled && (
            <Grid style={{ marginBottom: '10px' }}>
              <Grid.Row verticalAlign="middle" style={{ paddingBottom: 0 }}>
                <Grid.Column textAlign="left" width={6}>
                  <Header>Details</Header>
                </Grid.Column>
                <Grid.Column textAlign="right" width={10}>
                  <Button
                    basic
                    className="delete-spa-button"
                    onClick={this.handleShowModalConfirmDelete}
                    size="small"
                  >
                    <Icon name="delete" />Delete
                </Button>
                  <Button
                    basic
                    className="edit-spa-button"
                    onClick={this.handleOnEdit}
                    size="small"
                  >
                    <Icon name="pencil" />Edit
                </Button>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column width={8}>
                  <Grid>
                    <Grid.Row verticalAlign="middle">
                      <Grid.Column width={6} textAlign="left">
                        {t('Lawyer represents (e-SPA)')}
                      </Grid.Column>
                      <Grid.Column width={10} textAlign="right">
                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                          {SPA_LAWYER_REP_OPTIONS.find(opt => opt.value === data.repType).text}
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            )}
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={16}>
                <Header color={cancelled ? 'red' : null}>{t(`${cancelled ? 'Cancelled' : 'Assigned'} Lawyer`)}</Header>
              </Grid.Column>
            </Grid>
            {cancelled ? this.renderCancelled() : this.renderCurrent()}
          </Segment>
        ) : (
          <Segment basic padded>
            <Loader active inline="centered" />
          </Segment>
        )
      }
      </Grid.Column>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(SecondaryLawyerDetail);



// WEBPACK FOOTER //
// ./src/containers/Lawyer/SecondaryLawyerDetail.jsx